import { pdf } from '@react-pdf/renderer';

export const handlePrint = async (Component: JSX.Element, fileName = 'document.pdf') => {
  const blob = await pdf(Component).toBlob();
  const url = URL.createObjectURL(blob);
  const a = document.createElement('a');
  a.href = url;
  a.download = fileName;
  document.body.appendChild(a);
  a.click();
  document.body.removeChild(a);
  URL.revokeObjectURL(url);
};

// Next without validation
export const handleNext = (setStep: (cb: (step: number) => number) => void) => {
  setStep(prev => prev + 1);
};

// Next with form validation
export const handleValidatedNext = (
  validateForm: () => boolean,
  onNext: () => void
) => {
  if (validateForm()) {
    onNext();
  }
};

export const handlePrevious = (setStep: (cb: (step: number) => number) => void) => {
  setStep(prev => prev - 1);
};

// Fonction utilitaire pour fermer une page ou revenir en arrière
export const handleClose = (navigate: (to: number | string) => void, to: number | string = -1) => {
  navigate(to);
};

// Nouvelle fonction pour sauvegarder les brouillons
export const handleSaveDraft = async (
  formData: any,
  apiEndpoint: string = '/api/marche-subsequent',
  setIsSaving?: (state: boolean) => void,
  setSuccessMsg?: (message: string) => void,
  additionalData: object = {}
) => {
  if (setIsSaving) setIsSaving(true);
  if (setSuccessMsg) setSuccessMsg('');

  try {
    const response = await fetch(apiEndpoint, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        ...formData,
        status: 'Brouillon',
        ...additionalData
      })
    });

    if (!response.ok) throw new Error('Erreur lors de la sauvegarde');

    if (setSuccessMsg) setSuccessMsg('Votre brouillon a bien été sauvegardé.');
    return { success: true, data: await response.json() };
  } catch (e) {
    if (setSuccessMsg) setSuccessMsg("Erreur lors de la sauvegarde du brouillon.");
    return { success: false, error: e };
  } finally {
    if (setIsSaving) setIsSaving(false);
  }
};

/**
 * Generic handler for confirmation before executing an action
 * @param setIsModalOpen - Function to set modal visibility
 * @param onConfirm - Function to execute on confirmation
 * @param additionalCleanup - Optional cleanup function
 */
export const handleConfirm = (
  setIsModalOpen: (isOpen: boolean) => void,
  onConfirm: () => void,
  additionalCleanup?: () => void
) => {
  // Close the modal
  setIsModalOpen(false);

  // Execute the confirmation action
  onConfirm();

  // Run additional cleanup if provided
  if (additionalCleanup) {
    additionalCleanup();
  }
}

// CSV Export Functions
export function convertToCSV(data: any[], columns: {field: string, header: string}[]) {
  const headers = columns.map(col => col.header);
  const fields = columns.map(col => col.field);

  const csvRows = [
    headers.join(';'),
    ...data.map(row =>
      fields.map(field => {
        let value = row[field];
        if (typeof value === 'string') {
          value = value.replace(/"/g, '""').replace(/\n/g, ' ');
        }
        return `"${value ?? ''}"`;
      }).join(';')
    )
  ];
  return csvRows.join('\n');
}

export function downloadCSV(csv: string, filename = 'export.csv') {
  const blob = new Blob([csv], { type: 'text/csv;charset=utf-8;' });
  const link = document.createElement('a');
  link.href = URL.createObjectURL(blob);
  link.setAttribute('download', filename);
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
}

export const handleExportCSV = (data: any[], columns: {field: string, header: string}[], filename = 'export.csv') => {
  const csv = convertToCSV(data, columns);
  downloadCSV(csv, filename);
};